

























































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import Calendar from "../general/Calendar.vue";

import EventsEventDetails from "./EventsEventDetails.vue";

import EventJson, { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus } from "../../shared/EventBookingStatus";
import EventAppointmentJson from "../../shared/EventAppointmentJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";

import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";

export default Vue.extend({
  name: "EventsCalendarView",
  components: {
    Loading,
    Calendar,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    reload: Date,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      useFilters: false as boolean,
      selectedEventId: null as number | null,
      allEventAppointments: null as EventAppointmentJson[] | null,
      allCalendarEvents: null as CalendarEventJson[] | null,
      dateToShow: null as Date | null,
      currentCalenderYearMonth: null as [number, number] | null,
      showEventDetails: false,
      detailsMode: "read",
      filterCategoryTypeId: null as number | null,
      searchString: "",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", {
      account: true,
    });
    this.loadData();
  },
  methods: {
    async loadData() {
      await this.loadAllEventAppointmens();
      this.getCalendarEvents();
    },

    async loadAllEventAppointmens() {
      this.allEventAppointments = null;

      var searchString = null;
      var afterDateTime = null;

      if (this.restClient != null) {
        try {
          this.allEventAppointments = await this.restClient.getEventAppointments(searchString, afterDateTime);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllEventAppointmens();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    removeUseFilters() {
      this.useFilters = false;

      /* this.filterType = null
         this.filterState = null
         this.filterRenew = null */
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    //calendar view
    jumpToDateInCal(date: Date) {
      this.dateToShow = date;
    },

    getCalendarEvents() {
      this.allCalendarEvents = null;

      if (this.filteredAllEventAppointments) {
        this.allCalendarEvents = [];

        for (let appointment of this.filteredAllEventAppointments) {
          if (appointment.dates && appointment.dates.length > 0) {
            for (let date of appointment.dates) {
              let calendarEvent: CalendarEventJson = {
                title: "",
                beginDateTime: "",
                endDateTime: "",
                state: "",
                eventData: {},
              };

              calendarEvent.title = appointment.title;
              calendarEvent.beginDateTime = date.beginDateTime;
              calendarEvent.endDateTime = date.endDateTime;
              calendarEvent.state = appointment.state;

              appointment.location = date.location;

              calendarEvent.eventData = { ...appointment };

              this.allCalendarEvents.push(calendarEvent);
            }
          }
        }
      }
    },

    calenderCurrentYearMonth(year: number, month: number) {
      this.currentCalenderYearMonth = [year, month];
    },

    openDetails(eventAppointment: EventAppointmentJson) {
      this.$emit("openDetails", eventAppointment.eventId, eventAppointment.bookingId);
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    clientData: function () {
      this.reloadData();
    },

    reload: {
      handler(val, oldVal) {
        if (val != oldVal) this.reloadData();
      },
    },
  },
  computed: {
    allCategoryTypes(): CategoryTypeJson[] {
      let categories: CategoryTypeJson[] = [];

      if (this.allEventAppointments != null) {
        for (let eventAppointments of this.allEventAppointments) {
          if (eventAppointments.categories) {
            eventAppointments.categories.forEach((e: CategoryTypeJson) => categories.push(e));
          }
        }
      }

      return [...new Map(categories.map((i) => [i.ID, i])).values()];
    },

    filteredAllEventAppointments(): EventAppointmentJson[] | undefined {
      if (this.allEventAppointments != null) {
        var eventAppointments: EventAppointmentJson[] = this.allEventAppointments as EventAppointmentJson[];

        //categories
        if (this.filterCategoryTypeId != null) {
          eventAppointments = eventAppointments.filter(
            (e) =>
              e.categories != null &&
              e.categories.length > 0 &&
              e.categories.some((i) => i.ID == this.filterCategoryTypeId)
          );
        }

        return eventAppointments;
      }
    },
  },
});
